var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.result)?_c('ResultPage',{attrs:{"result":_vm.result}}):_c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }